import React, { useState, useEffect, useContext } from 'react';
import '../componentsCSS/DayCase.css';
import { UserContext } from '../UserContext';

const DayCase = ({ day, onClick }) => {
  const [isUnlocked, setUnlocked] = useState(false);
  const { userData } = useContext(UserContext);

  // Vérifier si la case est déjà ouverte au chargement
  useEffect(() => {
    const isAlreadyOpened = userData?.cases_opened?.includes(day) || false;
    setUnlocked(isAlreadyOpened);
  }, [day, userData]); // Recalculer chaque fois que userData change

  const unlockDay = () => {
    if (!userData) {
      alert("Veuillez vous connecter pour ouvrir cette case.");
      return;
    }

    // const today = new Date();
    // if (today.getDate() < day) { //(today.getDate() < day) {
    //   alert("Ce contenu n'est pas encore disponible !");
    //   return;
    // }

    onClick(day); // Passe le jour au Calendar pour gérer l'ouverture et l'ajout de points si nécessaire
  };

  // const today = new Date();

  return (
    <div 
      className={`day-case day-case${day} ${isUnlocked ? 'unlocked' : ''}`} 
      onClick={unlockDay}  
      style={{
        backgroundImage: isUnlocked
          ? `url('/images/unlocked-case/day${day}-unlocked.png')` // image à mettre à jour instantanément
          // : today.getDate()<day ? `url('/images/unlockable-case/${day+63}.png')`
          : `url('/images/locked-case/day${day}-locked.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        aspectRatio: '1 / 1',
      }}
    />
  );
};

export default DayCase;
